module.exports = __webpack_public_path__ + "static/img/2023_9_8_5.5da09ca5.5da09ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_5.5da09ca5.jpg
// module id = 5vJj
// module chunks = 0